import * as React from "react";
import type { SVGProps } from "react";
const SvgCondor = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 48 48"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      fill="#000"
      d="M2.002 24.038A21.78 21.78 0 0 1 24 2.001a21.78 21.78 0 0 1 21.999 22.037A21.725 21.725 0 0 1 24 45.998a21.72 21.72 0 0 1-21.998-21.96m2.045.042A19.724 19.724 0 0 0 24 44.055a19.723 19.723 0 0 0 19.95-19.972A19.8 19.8 0 0 0 24 4.023 19.8 19.8 0 0 0 4.047 24.08m2.588-6.561h10.554v1.842l-2.07.55 6.808 4.427s-3.652-3.215-2.475-5.604a2.75 2.75 0 0 1 2.64-1.218h19.37l-11.605 9.096-1.328-1.267 5.667-5.37H23.428c-.113 0-.613-.032-.784.362-.74 1.683 5.552 7.955 11.706 12.044l2.67 1.776v3.119z"
    />
  </svg>
);
export default SvgCondor;
